export const checkDuration = (item, onVideoLoaded) => {
  let url = URL.createObjectURL(item.getNative())
  let video = new Audio(url)
  video.addEventListener('loadedmetadata', function(_event) {
    onVideoLoaded(video)
  })
}
